var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.515625,
    y: 0.308594,
    width: 23.4147,
    height: 23.4147,
    rx: 3,
    fill: "#321E5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7626 3.09766C19.0062 3.09766 18.3906 3.71321 18.3906 4.46961C18.3906 5.22602 19.0062 5.84157 19.7626 5.84157C20.519 5.84157 21.1345 5.22602 21.1345 4.46961C21.1345 3.71321 20.519 3.09766 19.7626 3.09766Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2207 5.84375C8.81639 5.84375 6.04688 8.61327 6.04688 12.0175C6.04688 15.4218 8.81639 18.1913 12.2207 18.1913C15.6249 18.1913 18.3945 15.4218 18.3945 12.0175C18.3945 8.61327 15.6249 5.84375 12.2207 5.84375ZM12.2207 16.8194C9.5728 16.8194 7.41883 14.6654 7.41883 12.0175C7.41883 9.36967 9.5728 7.2157 12.2207 7.2157C14.8685 7.2157 17.0225 9.36967 17.0225 12.0175C17.0225 14.6654 14.8685 16.8194 12.2207 16.8194Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram1);
export default __webpack_public_path__ + "static/media/instagram 1.6f84dabe9458e673150e1ce86bcf603b.svg";
export { ForwardRef as ReactComponent };